// Based on Confluence's usage of the AK ProfileClient
// See: https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend
export const DEFAULT_PROFILE_DIR_URL = '/gateway/api/directory/graphql';
export const GATEWAY_GRAPHQL_URL = '/gateway/api/graphql';
